import React, { useState } from 'react';

import { If } from 'utils';
import { UiKit } from 'components';
import { useNotes } from 'utils/hooks';

export default function Form() {
  const [value, setValue] = useState('');

  const { isCreatable, isCreating, isDisabled, onCreate } = useNotes();

  return (
    <If test={isCreatable}>
      <UiKit.Grid templateColumns="1fr" gap="12" className="pt-3">
        <UiKit.Textarea
          autoFocus
          rows={3}
          value={value}
          onChange={setValue}
          disabled={isCreating || isDisabled}
          placeholder="Add your note here..."
        />
        <UiKit.Button
          size="sm"
          variant="outline"
          onClick={() => onCreate({ note: value }, err => !err && setValue(''))}
          disabled={!value || isDisabled}
          processing={isCreating}
          className="ml-auto"
        >
          Add Note
        </UiKit.Button>
      </UiKit.Grid>
    </If>
  );
}
